import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {GenericList} from '../../../models/list-item.model';
import { ConstService } from '../../../services/const.service';
import { MesAnioSelected } from 'src/models/data';

@Component({
  selector: 'app-mesanio',
  templateUrl: './mesanio.component.html',
  styleUrls: ['./mesanio.component.css']
})

export class MesanioComponent implements OnInit {
  @Output() selectedChange = new EventEmitter<MesAnioSelected>();

  anioSelectedHasta = new Date().getFullYear();
  mesSelectedHasta = 1;
  anioSelectedDesde = new Date().getFullYear();
  mesSelectedDesde = 1;
  anios = new GenericList();
  meses = new GenericList();

  constructor(private constService: ConstService) { }

  ngOnInit(): void {
    this.anios = this.constService.getAnios();
    this.meses = this.constService.getMeses();
  }

  cambiarAnioDesde(value){
    this.anioSelectedDesde = value;
  }

  cambiarMesDesde(value){
    this.mesSelectedDesde = value;
  }

  cambiarAnioHasta(value){
    this.anioSelectedHasta = value;
  }

  cambiarMesHasta(value){
    this.mesSelectedHasta = value;
  }

  monthDiff(dateFrom, dateTo) {
    return dateTo.getMonth() - dateFrom.getMonth() + 
      (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
   }

  aceptar(){
    if(this.mesSelectedHasta !== 0 && this.anioSelectedHasta !== 0){
      let mesAnioSelected = new MesAnioSelected();
      mesAnioSelected.mesdesde = this.mesSelectedDesde;
      mesAnioSelected.aniodesde = this.anioSelectedDesde;
      mesAnioSelected.meshasta = this.mesSelectedHasta;
      mesAnioSelected.aniohasta = this.anioSelectedHasta;

      this.selectedChange.emit(mesAnioSelected);
      //let diferencia =  this.monthDiff(desde, hasta);
    }else{
      alert('Debe seleccionar mes y año!.');
    }
  }
}
